import React, {useState} from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import * as Yup from 'yup';
import { useCommonEnquiryMutation } from '../../Store/Features/CommonFormAPI';
import { useRouter } from 'next/router';
import { encode } from '../../../utils/encrypt';
import CommonForm from '../../Common/CommonForm';

const ValuePropositionSection = ({ title = null, slug=null }) => {
    const [LoadingStatus, setLoadingStatus] = useState(false);
    const [formAPICallBack, { isLoading, error }] = useCommonEnquiryMutation();
    
    const { push } = useRouter();
    const endpoint='enquiry/email-subscription'
    const fields = [
        {
            name: 'email',
            type: 'email',
            placeholder: 'Email',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'
        }
    ];


    const PointsData = [
        {
            point: "Identify main competitors to help develop strategies",
        },
        {
            point: "Earmark market entry and exit opportunities",
        },
        {
            point: "Understand sub-populations to target for clinical development",
        },
        {
            point: "Track competition for your pipeline and marketed drugs",
        },
        {
            point: "Anticipate market changes through commercial milestone tracking",
        },
        {
            point: "Prioritize R&D spend by finding gaps and unmet needs",
        }
    ];

    const options={
        btn_name:'Submit',
        btnContainerClass:' mt-0'
    }

    const handleSubmit=(values)=>{
        setLoadingStatus(true)
        values.name = 'DelveInsightBusinessResearch';
        values.page_name = "CI Tracking";
        values.form_name = 'ci-tracking';
        values.source_url = window.location.href;
        values.source_url_from = document.referrer;
        values.datetime= new Date();

        formAPICallBack({
        data : { data: encode(values) },
        url : endpoint
        }).then((response) => {
            if (response) {
                if (response.data?.code == 200) {
                    setTimeout(() => {
                        push('/thank-you');
                        setLoadingStatus(false)
                    }, 1000);
                } else {
                    alert(response.data.message)
                }

            } else {
                let res = {
                    'message': "Error",
                    'status': false
                }
            }
        }) 
    }

    return (
        <div id="ValueProposition">
            <section className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
                <div className="grid grid-cols-12 gap-4">
                    <div className="lg:col-span-6 col-span-12">
                        <Image
                            priority={true}
                            width={2000}
                            height={2000}
                            src={process.env.IMG_CDN + 'img/consulting/jpg/ci-tracking/competitive-intelligence-tracking-insights-to-accurately.png'}
                            className="hidden lg:block w-full h-full"
                            alt="our Values"
                        />
                    </div>
                    <div className="lg:col-span-6 col-span-12">
                        {(title) &&
                            <SectionHeading
                                title={title}
                                customClass="text-center lg:text-left"
                            />
                        }
                        {PointsData?.map((item,index) => (
                            <div key={index} className="py-1"><span className="fa fa-check pr-10" style={{ color: '#2177e9' }}></span>{item?.point}</div>
                        ))}
                        <div className="text-center md:text-left mt-4">
                            <CommonForm 
                                fields={fields}
                                formTitle={'CI Tracking Email Subscription'}
                                onSubmit={handleSubmit}
                                // selectdFields={fields}
                                options={options}
                                captcha={ true }
                                isLoading={LoadingStatus}
                                page_name={'ci-tracking'}
                                form_name={'ci-traking-email-subscription'}
                                slug={slug}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ValuePropositionSection;